"use client";
import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "../../../../lib/utils";

const ButtonToggle = TabsPrimitive.Root;

const ButtonToggleList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "inline-flex h-9 items-center justify-center rounded-sm bg-semantic-secondary-background-heavy-defualt p-sp40 gap-sp80 typography-semantic-label-1-normal---medium",
      className
    )}
    {...props}
  />
));
ButtonToggleList.displayName = TabsPrimitive.List.displayName;

const ButtonToggleTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      [
        "rounded-sm inline-flex items-center justify-center whitespace-nowrap px-sp80 py-sp40",
        "transition-all duration-300 ",
        "focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50",
        "text-semantic-secondary-foreground-heavy-default",
        "data-[state=active]:bg-semantic-static-global-global-white",
        "data-[state=active]:shadow-[0px_0px_1px_0px_rgba(0,0,0,0.08),0px_0px_1px_0px_rgba(0,0,0,0.08),0px_1px_2px_0px_rgba(0,0,0,0.12)]",
      ],
      className
    )}
    {...props}
  />
));
ButtonToggleTrigger.displayName = TabsPrimitive.Trigger.displayName;

const ButtonToggleContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    )}
    {...props}
  />
));
ButtonToggleContent.displayName = TabsPrimitive.Content.displayName;

export {
  ButtonToggle,
  ButtonToggleList,
  ButtonToggleTrigger,
  ButtonToggleContent,
};
